module.exports = __webpack_public_path__ + "static/media/hanif_rizqi_m.a92a0ce0.jpg";